export const FETCH_RECENT_ACTIVITY = 'FETCH_RECENT_ACTIVITY';
export const FETCHING_RECENT_ACTIVITY = 'FETCHING_RECENT_ACTIVITY';
export const FETCH_RECENT_ACTIVITY_SUCCESS = 'FETCH_RECENT_ACTIVITY_SUCCESS';
export const FETCH_RECENT_ACTIVITY_FAILED = 'FETCH_RECENT_ACTIVITY_FAILED';

export function fetchRecentActivity(jobId, limit=10) {
  return {
    type: FETCH_RECENT_ACTIVITY,
    jobId,
    limit,
  };
}

export function fetchingRecentActivity(jobId) {
  return {
    type: FETCHING_RECENT_ACTIVITY,
    jobId,
  };
}

export function fetchRecentActivitySuccess(jobId, activity) {
  return {
    type: FETCH_RECENT_ACTIVITY_SUCCESS,
    jobId,
    activity,
  };
}

export function fetchRecentActivityFailed(jobId, error) {
  return {
    type: FETCH_RECENT_ACTIVITY_FAILED,
    jobId,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/actions/activity.js